<div class="fixed inset-0 z-[80] flex items-center justify-center p-4 bg-slate-900/50 backdrop-blur-sm" (click)="onClose()">
  <div class="w-full max-w-3xl max-h-[92vh] overflow-y-auto bg-white dark:bg-slate-800 rounded-[1.75rem] shadow-2xl border border-slate-100 dark:border-slate-700"
    (click)="$event.stopPropagation()">
    <div class="sticky top-0 z-10 flex items-center justify-between px-6 py-4 bg-white/95 dark:bg-slate-800/95 border-b border-slate-100 dark:border-slate-700 backdrop-blur">
      <h2 class="text-lg font-extrabold text-slate-800 dark:text-slate-100">
        {{ isEdit ? 'แก้ไขพื้นที่จอด' : 'เพิ่มพื้นที่จอด' }}
      </h2>
      <button type="button" (click)="onClose()" class="p-2 rounded-xl text-slate-400 hover:text-slate-700 hover:bg-slate-100 dark:hover:bg-slate-700 cursor-pointer">
        <span class="material-icons">close</span>
      </button>
    </div>

    <div class="p-6 space-y-5" [class.opacity-50]="isLoading()">
      <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
        <div class="md:col-span-2">
          <label class="block text-xs font-bold text-slate-500 mb-1">ชื่อ *</label>
          <input type="text" [(ngModel)]="formData.name"
            class="w-full px-3 py-2.5 rounded-xl border border-slate-200 dark:border-slate-600 bg-slate-50 dark:bg-slate-900 focus:ring-2 focus:ring-amber-200 outline-none" />
        </div>
        <div>
          <label class="block text-xs font-bold text-slate-500 mb-1">Lot</label>
          <input type="text" [(ngModel)]="formData.lot"
            class="w-full px-3 py-2.5 rounded-xl border border-slate-200 dark:border-slate-600 bg-slate-50 dark:bg-slate-900 focus:ring-2 focus:ring-amber-200 outline-none" />
        </div>
        <div>
          <label class="block text-xs font-bold text-slate-500 mb-1">Site</label>
          <input type="text" [ngModel]="formData.siteName || ('#' + formData.siteId)" disabled
            class="w-full px-3 py-2.5 rounded-xl border border-slate-200 dark:border-slate-600 bg-slate-100 dark:bg-slate-900/60 text-slate-500" />
        </div>
        <div>
          <label class="block text-xs font-bold text-slate-500 mb-1">Provider</label>
          <select [(ngModel)]="formData.providerId"
            class="w-full px-3 py-2.5 rounded-xl border border-slate-200 dark:border-slate-600 bg-slate-50 dark:bg-slate-900 focus:ring-2 focus:ring-amber-200 outline-none">
            <option [ngValue]="null">— เลือก —</option>
            <option *ngFor="let p of providers" [ngValue]="p.id">{{ p.name }}</option>
          </select>
        </div>
        <div>
          <label class="block text-xs font-bold text-slate-500 mb-1">Company ID</label>
          <input type="number" [(ngModel)]="formData.companyId"
            class="w-full px-3 py-2.5 rounded-xl border border-slate-200 dark:border-slate-600 bg-slate-50 dark:bg-slate-900 focus:ring-2 focus:ring-amber-200 outline-none" />
        </div>
        <div>
          <label class="block text-xs font-bold text-slate-500 mb-1">ประเภทรถ</label>
          <select [(ngModel)]="formData.vehicleTypeId"
            class="w-full px-3 py-2.5 rounded-xl border border-slate-200 dark:border-slate-600 bg-slate-50 dark:bg-slate-900 focus:ring-2 focus:ring-amber-200 outline-none">
            <option [ngValue]="null">— เลือก —</option>
            <option *ngFor="let v of vehicleTypes" [ngValue]="v.id">{{ v.name }}</option>
          </select>
        </div>
        <div class="flex items-end">
          <label class="inline-flex items-center gap-2 cursor-pointer select-none py-2.5">
            <input type="checkbox" [(ngModel)]="formData.isOnline" class="rounded border-slate-300 text-amber-500 focus:ring-amber-300" />
            <span class="text-sm font-semibold">Online</span>
          </label>
        </div>
      </div>

      <div>
        <h3 class="text-sm font-extrabold text-slate-700 dark:text-slate-200 mb-3">รูปภาพ (base64) — จะถูกบีบขนาดตอนบันทึก</h3>
        <div class="grid grid-cols-1 sm:grid-cols-2 gap-4">
          <div *ngFor="let slot of [1,2,3,4]" class="rounded-2xl border border-slate-200 dark:border-slate-600 p-3 bg-slate-50/80 dark:bg-slate-900/40">
            <div class="flex items-center justify-between mb-2">
              <span class="text-xs font-bold text-slate-500">Image {{ slot }}</span>
              <button type="button" (click)="clearImage($any(slot))" class="text-[11px] font-bold text-rose-500 cursor-pointer">ลบ</button>
            </div>
            <div class="aspect-video rounded-xl overflow-hidden bg-slate-200/60 dark:bg-slate-700 mb-2 flex items-center justify-center">
              <img *ngIf="(slot===1 && formData.image1Base64) || (slot===2 && formData.image2Base64) || (slot===3 && formData.image3Base64) || (slot===4 && formData.image4Base64)"
                [src]="imagePreview(slot===1 ? formData.image1Base64 : slot===2 ? formData.image2Base64 : slot===3 ? formData.image3Base64 : formData.image4Base64)"
                class="w-full h-full object-cover" alt="preview" />
              <span *ngIf="!((slot===1 && formData.image1Base64) || (slot===2 && formData.image2Base64) || (slot===3 && formData.image3Base64) || (slot===4 && formData.image4Base64))"
                class="text-xs text-slate-400">ยังไม่มีรูป</span>
            </div>
            <input type="file" accept="image/*" (change)="onPickImage($any(slot), $event)"
              class="block w-full text-xs text-slate-500 file:mr-3 file:py-1.5 file:px-3 file:rounded-lg file:border-0 file:bg-amber-100 file:text-amber-700 file:font-bold cursor-pointer" />
          </div>
        </div>
      </div>
    </div>

    <div class="sticky bottom-0 flex justify-between gap-3 px-6 py-4 bg-white/95 dark:bg-slate-800/95 border-t border-slate-100 dark:border-slate-700">
      <button *ngIf="canShowActivityHistory" type="button" (click)="openActivityHistory()" [disabled]="isSaving() || isLoading()"
        class="px-4 py-2.5 rounded-xl border border-slate-200 dark:border-slate-700 text-slate-500 font-bold hover:border-amber-400 hover:text-amber-600 transition-all cursor-pointer inline-flex items-center justify-center gap-2 disabled:opacity-50">
        <span class="material-icons text-[18px]">history</span>
        ดูประวัติ
      </button>
      <div class="flex justify-end gap-3 ml-auto">
        <button type="button" (click)="onClose()"
          class="px-4 py-2.5 rounded-xl font-bold text-slate-500 hover:bg-slate-100 dark:hover:bg-slate-700 cursor-pointer">ยกเลิก</button>
        <button type="button" (click)="onSave()" [disabled]="isSaving() || isLoading()"
          class="px-5 py-2.5 rounded-xl font-bold bg-amber-400 hover:bg-amber-500 text-white disabled:opacity-50 cursor-pointer">
          {{ isSaving() ? 'กำลังบันทึก...' : 'บันทึก' }}
        </button>
      </div>
    </div>
  </div>
</div>

<app-modal-admin-activity-history
  *ngIf="showActivityHistory && itemId"
  [entityType]="activityEntityTypes.ParkingArea"
  [entityId]="itemId"
  title="ประวัติพื้นที่จอด"
  [subtitle]="'#' + itemId"
  (close)="closeActivityHistory()">
</app-modal-admin-activity-history>
